:host {
  display: block;
}

.signet-button {
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  outline: 0px;
  border: 0px;
  margin: 0px;
  cursor: pointer;
  user-select: none;
  vertical-align: middle;
  appearance: none;
  text-decoration: none;
  font-family: Lato, Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.6;
  letter-spacing: 0.02857em;
  text-transform: uppercase !important;
  max-width: 100%;
  padding: 6px 14px;
  border-radius: 4px;
  overflow: hidden;
  transition: background 400ms;
  color: var(--pure-white);
  background-color: var(--primary-main);
  height: 30px;
}

.primary.signet-button {
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  color: var(--pure-white);
  background-color: var(--action-default);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,
    rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
  text-transform: uppercase;
}

.text.signet-button {
  background-color: transparent;
  padding: 6px 8px;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  color: var(--action-default);
}

.outlined.signet-button {
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border: 1px solid;
  border-color: var(--action-default);
  color: var(--action-default);
  background-color: transparent;
}

.signet-button.primary:hover {
  background-color: var(--action-default);
}

.signet-button.text:hover,
.signet-button.outlined:hover {
  background-color: var(--state-background-hover);
}

.signet-button:disabled {
  cursor: not-allowed !important;
  background-color: var(--gray-200) !important;
  color: rgba(0, 0, 0, 0.7) !important;
}

span.ripple {
  position: absolute;
  border-radius: 50%;
  transform: scale(0);
  animation: ripple 600ms linear;
  background-color: rgba(255, 255, 255, 0.3);
}

signet-button[size="sm"] .signet-button {
  font-size: 10px;
  padding: 5px 8px;
  height: 26px;
}
signet-button[size="lg"] .signet-button {
  font-size: 12px;
  padding: 7px 20px;
  height: 34px;
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 0;
  }
}
